import { useQuery } from "react-query";
import { getRehireFranchiseEmployeeCount } from "../../../../../actions/Employees";

const useGetRehireFranchiseEmployeeCount = () => {
  return useQuery(
    "GetRehireFranchiseEmployeeCount",
    getRehireFranchiseEmployeeCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetRehireFranchiseEmployeeCount;
